import React, { useCallback } from 'react';
import { useSwipeableProductImages } from '../../hooks/useSwipeableProductImages';

/**
 * Liste / ana sayfa ürün kartı görsel alanı — mobilde kaydır, masaüstünde hover bölgeleri (parent).
 */
const ProductCardSwipeGallery = ({
  images,
  currentIndex,
  onIndexChange,
  getImageUrl,
  productName,
  brand,
  categories,
  imageClassName = 'w-full h-full object-contain p-4 group-hover:scale-105 transition-all duration-300 ease-in-out',
}) => {
  const count = images?.length || 0;
  const safeIndex = count > 0 ? Math.min(currentIndex, count - 1) : 0;

  const handleSwipe = useCallback(
    (direction) => {
      if (count <= 1) return;
      const cur = safeIndex;
      const next =
        direction === 'next'
          ? (cur + 1) % count
          : cur === 0
            ? count - 1
            : cur - 1;
      onIndexChange(next);
    },
    [count, safeIndex, onIndexChange]
  );

  const { containerRef, swipeHandlers, swipeEnabled } = useSwipeableProductImages(
    count,
    handleSwipe
  );

  if (!count) {
    return (
      <div className="aspect-square bg-gray-200 flex items-center justify-center">
        <span className="text-gray-400 text-sm">Resim Yok</span>
      </div>
    );
  }

  const imageUrl =
    images[safeIndex]?.url != null ? images[safeIndex].url : images[0].url;

  return (
    <div
      ref={containerRef}
      className={`aspect-square bg-white relative overflow-hidden touch-pan-y ${
        swipeEnabled ? 'select-none' : ''
      }`}
      {...swipeHandlers}
    >
      <img
        src={getImageUrl(imageUrl)}
        alt={`${productName} - ${brand || ''} - ${categories?.join(', ') || ''} - LeaserTech`}
        title={productName}
        className={imageClassName}
        crossOrigin="anonymous"
        loading="lazy"
        draggable={false}
        onError={(e) => {
          e.target.src =
            'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjNmNGY2Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5YTNhZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkdyw7xzw7xsIFlva8SxPC90ZXh0Pjwvc3ZnPg==';
        }}
      />

      {count > 1 && (
        <div
          className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-1 z-20 pointer-events-none"
          aria-hidden
        >
          {images.map((_, index) => (
            <div
              key={index}
              className={`w-2 h-2 rounded-full transition-colors duration-200 ${
                safeIndex === index ? 'bg-gray-800' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductCardSwipeGallery;
